import { Component, inject } from '@angular/core';
import { UserAgentService } from '../../../core/services/user-agent.service';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-user-agent-outdated-banner',
  imports: [MatIcon, MatIconButton, TranslatePipe],
  templateUrl: './user-agent-outdated-banner.html',
  styleUrl: './user-agent-outdated-banner.scss',
})
export class UserAgentOutdatedBanner {
  readonly deviceService = inject(UserAgentService);

  dismiss(): void {
    this.deviceService.dismissWarning();
  }
}
